import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { trackEvent } from '../utils/analytics';

const points = [
  "Imballaggio e protezione",
  "Smontaggio e rimontaggio",
  "Trasporto puntuale"
];

export default function Traslochi() {
  return (
    <section className="py-24 bg-maaich-black relative overflow-hidden">
      <div className="container mx-auto px-5 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          
          <motion.div 
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <h2 className="text-4xl md:text-6xl font-display uppercase italic mb-8">
              Servizio di <span className="text-maaich-lime">traslochi</span> in tutta la Lombardia nord
            </h2>
            <p className="text-lg md:text-xl text-white/70 font-body font-light mb-10 leading-relaxed">
              Oltre agli sgomberi, ti accompagniamo nel trasloco: imballaggio dei tuoi beni con materiali adeguati, smontaggio e rimontaggio dei mobili, trasporto sicuro e sistemazione nella nuova casa o ufficio. Un servizio pensato per farti cambiare casa senza stress.
            </p>

            <div className="space-y-5 mb-10">
              {points.map((point, idx) => (
                <div key={idx} className="flex items-center gap-4">
                  <div className="w-6 h-6 bg-maaich-lime/20 flex items-center justify-center rounded-full flex-shrink-0">
                    <SafeIcon icon={FiIcons.FiCheck} className="text-maaich-lime text-sm" />
                  </div>
                  <span className="text-white/90 font-display uppercase italic text-lg tracking-wide">{point}</span>
                </div>
              ))}
            </div>

            <a 
              href="https://wa.me/393921037894?text=Ciao%2C%20vorrei%20un%20preventivo%20per%20un%20trasloco." 
              target="_blank" 
              rel="noreferrer"
              onClick={() => trackEvent('whatsapp_click', 'traslochi')}
              className="inline-flex items-center gap-3 bg-white/5 border border-white/20 hover:border-maaich-lime px-8 py-5 font-display uppercase italic text-xl transition-all group w-full sm:w-auto justify-center"
            >
              Richiedi preventivo trasloco
              <SafeIcon icon={FiIcons.FiArrowRight} className="group-hover:translate-x-2 transition-transform" />
            </a>
          </motion.div>

          <motion.div 
            className="relative rounded-2xl overflow-hidden shadow-[0_20px_50px_rgba(0,0,0,0.6)] border border-white/10 group"
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <img 
              src="https://media-manager-c.questera.ai/greta-media/199587cac76451c8a0c81fe29a304b4dfef859bf4c50d3d87f3dadd96dddc39882a7b9b97ef41b50b9892514b6d5ef47/images/aW1hZ2UvcG5n/1e3d2c18c0e8112f2c98d024e230a0a0.png" 
              alt="Squadra MAAICH durante un servizio di trasloco in Lombardia" 
              className="w-full aspect-[4/3] md:aspect-auto md:h-[500px] object-cover group-hover:scale-105 transition-transform duration-1000"
              loading="lazy"
              width="600"
              height="450"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent pointer-events-none"></div>
          </motion.div>

        </div>
      </div>
    </section>
  );
}